import React, { useState } from "react";
import { Button, Card, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styles from "./videoCard.module.scss";
import ReactPlayer from "react-player/lazy";
import { toast } from "react-toastify";
import ClickAwayListener from "react-click-away-listener";
import { SupportVideoDto } from "../../../../models/supportVideoDto";
import { translate } from "react-switch-lang";
import hasRoles from "../../../../security/hasRoles";
import keycloak from "../../../../security/keycloak-config";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";

const VideoCard: React.FC<{
  t: (key: string) => {};
  //   categoryId: number;
  //   setFilteredDocuments: (listVideo: SupportVideoDto) => void;
  handleClickOpenModalEditSupport: (data: SupportVideoDto) => void;
  handleClickOpenVideoViewer: (data: SupportVideoDto) => void;
  handleDeleteSUpportVideo: (supportId: number) => void;
  //   path: string;
  data: SupportVideoDto;
}> = ({ t, data, handleClickOpenModalEditSupport, handleDeleteSUpportVideo, handleClickOpenVideoViewer }) => {
  const [langdropdown, setLangdropdown] = useState(false);
  const [elementSelected, setElementSelected] = useState<SupportVideoDto>(new SupportVideoDto());
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);

  toast.configure();
  const handleSetLanguage = key => {
    setLangdropdown(!langdropdown);
  };
  const LanguageSelection = language => {
    setLangdropdown(!language);
  };
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);

  const openModel = (url) => {
    setUrl(url)
    toggle()
  };

  const [modal, setModal] = useState(false);
  const [url, setUrl] = useState('');
  const toggle = () => setModal(!modal);

  const closeModel = () => {
    setModal(false);
  };

  const redirectToSupport = (url) => {
    window.open(url, '_blank');
    closeModel();
  };
  
  return (
    <>
      <Modal className={styles["modal-aide"]} isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("model_video_title")}</ModalHeader>
        <ModalBody>
        <Input className="form-control" type="email" readOnly value={url}/>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={() =>redirectToSupport(url)}>
          {t("model_video_button")}
          </Button>
        </ModalFooter>
      </Modal>
      <Card className={styles["card-document"]}>
        <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
          <div onClick={event => event.stopPropagation()} className="product-img text-center">
            {data.urlSupport ? (
              <img className={styles["img-card-video"]} src={data.urlSupport + "/preview"} alt="" />
            ) : (
              <div className={styles["react-player-container"]}>
                <ReactPlayer
                  url={data.link}
                  width="100%"
                  height="195px"
                  onError={() => {
                    toast.error(t("message_toastr_inaccessible_video"), {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 5000,
                    });
                  }}
                  playing={data.urlSupport ? true : false}
                  controls={true}
                  light={data.urlSupport ? data.urlSupport + "/preview" : false}
                />
              </div>
            )}
            <div className="product-hover">
              <ul>
                <li
                  onClick={() => {
                    handleClickOpenVideoViewer(data);
                  }}
                  style={{ width: "auto" }}
                >
                  <i className="icon-eye">
                    <span className="m-l-5">{hasRoleAdmin && data.numberView}</span>
                  </i>
                </li>
                <li onClick={() => openModel(data.link)} style={{ width: "auto" }}>
                  <i className="fa fa-share-alt"></i>
                </li>
              </ul>
            </div>
          </div>
          <div className="blog-details-main">
            <h6 title={data.title} className={styles["title-card"] + " blog-bottom-details"}>
              {data.title}
            </h6>
            <hr />
            <ul className="blog-social">
              <li className="digits">
                <i className={styles["icon-timer"] + " icofont icofont-ui-timer"}></i> {data.dateSupport}
              </li>
              <li className={"digits"}>
                <span title={data.listCountry.map(element => selectedLanguage === "en" ? element.titleAnglais : element.titleFrancais).toString()}>
                  {data.listCountry.length === 1 
                  ? selectedLanguage === "en" ? data?.listCountry[0]?.titleAnglais : data?.listCountry[0]?.titleFrancais 
                  : t("multi_countries")}
                </span>
              </li>
              {hasRoleAdmin && (
                <li className="digits">
                  <ClickAwayListener
                    onClickAway={() => {
                      handleSetLanguage("en");
                      setElementSelected(new SupportVideoDto());
                    }}
                  >
                    <div className={`${styles["translate_wrapper"]} ${langdropdown && elementSelected.supportId === data.supportId ? styles["active"] : ""}`}>
                      <div className={styles["current_lang"]}>
                        <div
                          className={styles["lang"]}
                          onClick={() => {
                            setElementSelected(data);
                            LanguageSelection(langdropdown);
                          }}
                        >
                          <i className="fa fa-gear"></i>
                        </div>
                      </div>

                      <div className={`${styles["more_lang"]} ${langdropdown ? styles["active"] : ""}`}>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            event.stopPropagation();
                            handleSetLanguage("en");
                            handleClickOpenModalEditSupport(data);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-edit " + styles["icon-update"]}></i>
                          <span className={styles["lang-txt"]}> {t("button_update")}</span>
                        </div>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            handleSetLanguage("fr");
                            event.stopPropagation();
                            handleDeleteSUpportVideo(data.supportId);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-trash " + styles["icon-delete"]}></i>
                          <span className={styles["lang-txt"]}>{t("button_delete")}</span>
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Card>
    </>
  );
};

export default translate(VideoCard);
